<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction: The Adirondack Mountains</a></p>
<p class="toc1"><a href="#/chapter01">1. Nat Foster, Indian Killer</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Slaves in the Mountains</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Mad Father Craven</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Don’t Steal the Timber</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. The Windfall Gang</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. The Great Adirondack Stagecoach Robbery</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. A Bad Man in the Adirondack Jungle</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Millionaire Land Baron Assassination</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. The Grace Brown and Chester Gillette Tragedy</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Gangster Dutch Schultz Goes on Trial</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. The Hollywood Golfing Elite Hobnob Accused Robber</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Air Force War Hero Turned Cop Killer</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Burn, Baby, Burn</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. Stick ’Em Up!</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. The Adirondack Serial Killer</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">16. Acid Rain Apocalypse</span></p>
<p class="toc1"><span href="#/appendix" title="Link target outside of Sample">Appendix: Maps of the Adirondack Mountains</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?43d5d28e